module.exports = __webpack_public_path__ + "img/companyManagement.2597b5ff.svg";